import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

export const workerSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  calendarId: z.string().email(),
  rate: z.number().nullable(),
  active: z.boolean(),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

export const workerInputSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  calendarId: z.string().email('Valid calendar email/ID is required'),
  // Optional means "not supplied"; an explicit null clears the rate.
  rate: z.number().min(0, 'Rate cannot be negative').nullable().optional(),
  active: z.boolean().default(true).optional(),
});

export const workerUpdateSchema = z.object({
  name: z.string().min(1, 'Name is required').optional(),
  calendarId: z.string().email('Valid calendar email/ID is required').optional(),
  rate: z.number().min(0, 'Rate cannot be negative').nullable().optional(),
  active: z.boolean().optional(),
});
